<template>
  <div>
    <v-simple-table>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Descripción</th>
            <th class="text-center">Cantidad</th>
            <th width="150"></th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="agrupador in listadoInsumos">
            <template>
              <tr
                :key="`agrupador-${agrupador.agrupador}`">
                <td
                  colspan="5"
                  class="grey lighten-3">
                  <h3>{{ agrupador.agrupador }}</h3>
                </td>
              </tr>
              <!-- Listado de insumos -->
              <template
                v-for="insumo in agrupador.insumos">
                <template>
                  <tr
                    :key="`insumo-${insumo.id}`">
                    <td>
                      {{ insumo.insumo.orden }}
                    </td>
                    <td>
                      {{ insumo.insumo.descripcion }}
                    </td>
                    <td
                      class="text-center">
                      <v-chip
                        color="info">
                        {{ insumo.cantidad }}
                      </v-chip>
                    </td>
                    <td>
                      <v-tooltip
                        v-if="mixValidaScopesActions(2)"
                        top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" @click="editar(insumo)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="mixValidaScopesActions(3)"
                        top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(insumo)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Borrar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoInsumos',
  props: {
    listadoInsumos: {
      type: Array,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    editar(insumoContrato) {
      eventBus.$emit('editar-insumo-contrato', insumoContrato);
    },
    borrar(insumoContrato) {
      eventBus.$emit('eliminar-insumo-contrato', insumoContrato);
    },
  },
};
</script>

<style lang="scss">

</style>
